import { render, staticRenderFns } from "./JournalTagsSelect.vue?vue&type=template&id=94403876&scoped=true"
import script from "./JournalTagsSelect.vue?vue&type=script&lang=js"
export * from "./JournalTagsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94403876",
  null
  
)

export default component.exports